import styles from '../index.module.less'
import { Card } from '@modules/missions/keaz/step/components/card'
import { PhotoView } from '@modules/missions/keaz/step/components/photoView'
import { FormGroup } from '@modules/missions/keaz/step/components/formGroup'
import {
  ElectricalStepCurrentCheckUnderLoad,
  ElectricalStepCurrentCheckUnderLoadFields
} from '@modules/missions/keaz/types'
import { DeviationsFormFields } from '@modules/missions/keaz/step/components/contentBySteps/components/deviationsFormFields'
import { TextField } from '@smwb/summer-ui/dist/connects/rff'
import React from 'react'
import { StepForm } from '@modules/missions/keaz/step/components/stepForm'

export interface CurrentCheckUnderLoadProps {
  compact: boolean
  step: ElectricalStepCurrentCheckUnderLoad
  isEditableStep: boolean
  setCompact: React.Dispatch<React.SetStateAction<boolean>>
  onBackClick: () => void
  refetchReports: () => void
}

export function CurrentCheckUnderLoad({
  compact,
  step,
  isEditableStep,
  setCompact,
  onBackClick,
  refetchReports
}: CurrentCheckUnderLoadProps) {
  return (
    <div>
      <StepForm<ElectricalStepCurrentCheckUnderLoad>
        step={step}
        compact={compact}
        isEditableStep={isEditableStep}
        setCompact={setCompact}
        onBackClick={onBackClick}
        refetchReports={refetchReports}
      >
        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <TextField
              name={ElectricalStepCurrentCheckUnderLoadFields.currentReadingPoint1}
              type='number'
              label='Показания тока для точки №1'
              fullWidth={true}
              disabled={compact}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<ElectricalStepCurrentCheckUnderLoad>
              compact={compact}
              title='Фото показаний с дисплея токовых клещей для точки №1'
              fieldName={ElectricalStepCurrentCheckUnderLoadFields.currentDisplayPhotoPoint1}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <TextField
              name={ElectricalStepCurrentCheckUnderLoadFields.currentReadingPoint2}
              type='number'
              label='Показания тока для точки №2'
              fullWidth={true}
              disabled={compact}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<ElectricalStepCurrentCheckUnderLoad>
              compact={compact}
              title='Фото показаний с дисплея токовых клещей для точки №2'
              fieldName={ElectricalStepCurrentCheckUnderLoadFields.currentDisplayPhotoPoint2}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <TextField
              name={ElectricalStepCurrentCheckUnderLoadFields.currentReadingPoint3}
              type='number'
              label='Показания тока для точки №3'
              fullWidth={true}
              disabled={compact}
            />
          </Card>
        </FormGroup>

        <FormGroup compact={compact}>
          <Card className={styles.card}>
            <PhotoView<ElectricalStepCurrentCheckUnderLoad>
              compact={compact}
              title='Фото показаний с дисплея токовых клещей для точки №3'
              fieldName={ElectricalStepCurrentCheckUnderLoadFields.currentDisplayPhotoPoint3}
            />
          </Card>
        </FormGroup>

        <DeviationsFormFields
          compact={compact}
          detectedFieldName={ElectricalStepCurrentCheckUnderLoadFields.deviations}
          commentFieldName={ElectricalStepCurrentCheckUnderLoadFields.deviationsComment}
          className={styles.deviationsFields}
        />
      </StepForm>
    </div>
  )
}
